import { all_routes } from "../../../router/all_routes";
import { RolesEnum } from "../../../types/route.types";
import { SidebarItem } from "../../../types/sidebar.types";
import { PermissionType } from "../../../types/user.types";
const routes = all_routes;

// ⚠️ CRITICAL: Sub durumuna göre menü filtreleme fonksiyonu
export const filterMenuBySubStatus = (menuItems: SidebarItem[], sub: any, user: any): SidebarItem[] => {
  if (!sub) return menuItems;
  
  // 🔥 SuperAdmin'ler abonelik kontrolünden muaf - her zaman normal menüyü göster
  const isSuperAdmin = user?.role === RolesEnum.SUPERADMIN;
  if (isSuperAdmin) {
    return menuItems;
  }
  
  // 🚨 EXPIRED = TRUE: Sadece pricing sayfasına erişim ver (SuperAdmin hariç)
  if (sub.status === 'expired' || sub.status === 'inactive') {
    return [{
      tittle: sub.status === 'trial' ? 'Deneme Süresi Bitti' : 'Abonelik Süresi Bitti',
      icon: 'alert-triangle',
      showAsTab: false,
      separateRoute: true,
      role: [PermissionType.PRICING_ACCESS],
      submenuItems: [{
        label: sub.status === 'trial' ? 'Premium Planı Satın Al' : 'Aboneliği Yenile',
        link: routes.pricing,
        base: 'pricing',
        icon: 'credit-card',
        role: [PermissionType.PRICING_ACCESS],
      }]
    }];
  }
  
  // 🟢 EXPIRED = FALSE: Normal menü (trial ya da premium fark etmez)
  // Trial kullanıcılar Company Settings'de premium plan tanıtımını görür
  // Premium kullanıcılar Company Settings'de plan yönetimi yapar
  // Sidebar'da ek menü eklemeye gerek yok
  return menuItems;
};
export const SidebarDataTest:SidebarItem[] = [
  {
    tittle: 'sidebar_menu.main_menu.userTitle',
    icon: 'airplay',
    showAsTab: true,
    separateRoute: false,
    role:[PermissionType.CONTROL_PANEL_USER],
    submenuItems: [
     
      {
        label: 'sidebar_menu.main_menu.dashboard',
        link: routes.employeeDashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'smart-home',
        base: 'dashboard',
        role:[PermissionType.CONTROL_PANEL_USER],
        materialicons: 'start',
      },


      {
        label: 'sidebar_menu.hrm.tickets',
        link: routes.ticketEmployee,
        base: 'ticket-list',
        role:[PermissionType.VIEW_TICKETS_USER],
        icon: 'ticket',
      },

      {
        label: 'sidebar_menu.hrm.leaves',
        link: routes.leaveemployee,
        submenu: false,
        showSubRoute: false,
        role:[PermissionType.LEAVE_REQUEST],
        icon: 'check',
      },
 


    ],
  },

  {
    tittle: 'sidebar_menu.main_menu.adminTitle',
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    role:[PermissionType.CONTROL_PANEL_ADMIN],
    submenuItems: [
      {
        label: 'sidebar_menu.main_menu.dashboard',
        link: routes.adminDashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'smart-home',
        base: 'dashboard',
        role:[PermissionType.CONTROL_PANEL_ADMIN],
        materialicons: 'start',
      },
      {
        label: 'sidebar_menu.hrm.employee_list',
        link: routes.employeeList,
        submenu: false,
        showSubRoute: false,
        base: 'dashboard',
        role:[PermissionType.VIEW_USERS],
        icon: 'users',
      },
      {
        label: 'sidebar_menu.hrm.departments',
        link: routes.departments,
        base: 'departments',
        role:[PermissionType.VIEW_DEPARTMENTS],
        icon: 'category',
      },
      {
        link:routes.branches,
        label: 'sidebar_menu.administration.branch',
        base: 'stores',
        submenu: false,
        showSubRoute: false,
        icon: 'building',
        role:[PermissionType.VIEW_BRANCHES],
      },
      {
        link:routes.attendance,
        label: 'sidebar_menu.administration.attendance',
        base: 'attendance-report',
        icon: 'receipt',
        role:[PermissionType.VIEW_REPORTS],
      },
      {
        label: 'sidebar_menu.administration.shift',
        link: routes.shift,
        base: 'shift',
        role:[PermissionType.MANAGE_SHIFTS],
        icon: 'calendar',
      },
      {
        label: 'sidebar_menu.hrm.leaves',
        link: routes.leaveadmin,
        role:[PermissionType.VIEW_LEAVE],
        icon: 'check',
      },
      {
        label: 'sidebar_menu.hrm.tickets',
        link: routes.ticketAdmin,
        base: 'ticket-list',
        role:[PermissionType.VIEW_TICKETS_ADMIN],
        icon: 'ticket',
      },
      {
        label: 'sidebar_menu.hrm.forgotten_checkouts',
        link: routes.forgotCheckOut,
        base: 'forgotten-checkouts',
        role:[PermissionType.VIEW_REPORTS],
        icon: 'user',
      },
      {
        label: 'sidebar_menu.hrm.forgotten_checkin',
        link: routes.forgotCheckIn,
        base: 'forgotten-checkin',
        role:[PermissionType.VIEW_REPORTS],
        icon: 'user',
      },
      {
        link:routes.assets,
        label: 'sidebar_menu.administration.assets',
        base: 'assets',
        icon: 'archive',
        role:[PermissionType.VIEW_ASSETS],
      },
    ],
  },
 
  {
    tittle: 'sidebar_menu.main_menu.reportsTitle',
    icon: 'file',
    showAsTab: true,
    separateRoute: false,
    role:[PermissionType.VIEW_REPORTS],
    submenuItems: [
      {
        link:routes.employeeReport,
        label: 'sidebar_menu.administration.employee_report',
        base: 'employee-report',
        icon: 'users',
        role:[PermissionType.VIEW_REPORTS],
      },
      {
        link:routes.shiftReport,
        label: 'sidebar_menu.administration.shift_report',
        base: 'shift-report',
        icon: 'calendar',
        role:[PermissionType.VIEW_REPORTS],
      },
      // {
      //   link:routes.ticketReport,
      //   label: 'sidebar_menu.administration.ticket_report',
      //   base: 'ticket-report',
      //   icon: 'ticket',
      //   role:[PermissionType.VIEW_TICKETS_ADMIN],
      // },
      
      // {
      //   link:routes.attendanceReport,
      //   label: 'sidebar_menu.administration.attendance_report',
      //   base: 'attendance-report',
      //   icon: 'receipt',
      //   role:RolesEnum.ADMIN,
      // },
   
      {
        link:routes.leaveReport,
        label: 'sidebar_menu.administration.leave_report',
        base: 'leave-report',
        icon: 'check',
        role:[PermissionType.VIEW_LEAVE],
      },
      {
        label: 'sidebar_menu.administration.break_report',
        link: routes.breakReport,
        base: 'employeesReports',
        role:[PermissionType.VIEW_REPORTS],
        icon: 'receipt',
      },
      {
        label: 'sidebar_menu.administration.documents',
        link: routes.documents,
        base: 'documents',
        role:[PermissionType.FILE_VIEW],
        icon: 'file-text',
      }
    ],
  },
  {
    tittle: 'sidebar_menu.main_menu.settingsTitle',
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    role:[PermissionType.COMPANY],
    submenuItems: [
      {
        link:routes.companySettings,
        label: 'sidebar_menu.administration.company_settings',
        base: 'company-settings',
        icon: 'settings',
        role:[PermissionType.COMPANY],
      },
      {
        link:routes.notification,
        label: 'sidebar_menu.administration.notification',
        base: 'notification',
        icon: 'bell',
        role:[PermissionType.CREATE_NOTIFICATIONS],
      },
 
      ]
    },

    {
      tittle: 'sidebar_menu.main_menu.superAdminTitle',
      icon: 'file',
      showAsTab: false,
      separateRoute: false,
      role:[PermissionType.MANAGE_COMPANY],
      submenuItems: [
        {
          link:routes.superAdminDashboard2,
          label: 'sidebar_menu.administration.dashboard',
          base: 'dashboard',
          icon: 'smart-home',
          role:[PermissionType.MANAGE_COMPANY],
        },
        {
          link:routes.superAdminAboutUs,
          label: 'Hakkımızda',
          base: 'about-us',
          icon: 'info',
          role:[PermissionType.MANAGE_COMPANY],
        },

      ]
    },

    {
      tittle: 'sidebar_menu.main_menu.companyTitle',
      icon: 'file',
      showAsTab: false,
      separateRoute: false,
      role:[PermissionType.MANAGE_COMPANY],
      submenuItems: [
        {
          link:routes.superAdminCompanies,
          label: 'sidebar_menu.administration.companies',
          base: 'companies',
          icon: 'users',
          role:[PermissionType.MANAGE_COMPANY],
        },

        {
          link:routes.superAdminCompanyCreate,
          label: 'sidebar_menu.administration.company_create',
          base: 'company-create',
          icon: 'plus',
          role:[PermissionType.MANAGE_COMPANY],
        }
      ]
    },

    {
      tittle: 'sidebar_menu.main_menu.couponsTitle',
      icon: 'file',
      showAsTab: false,
      separateRoute: false,
      role:[PermissionType.MANAGE_COMPANY],
      submenuItems: [
        {
          link:routes.coupons,
          label: 'Kupon Yönetimi',
          base: 'coupons',
          icon: 'ticket',
          role:[PermissionType.MANAGE_COMPANY],
        },
      ]
    },
    {
      tittle: 'sidebar_menu.main_menu.paymentTitle',
      icon: 'file',
      showAsTab: false,
      separateRoute: false,
      role:[PermissionType.MANAGE_COMPANY],
      submenuItems: [
        
        {
          link:routes.paymentReports,
          label: 'Ödeme Raporları',
          base: 'payment-reports',
          icon: 'report-money',
          role:[PermissionType.MANAGE_COMPANY],
        },
      ]

    },
    {
      tittle: 'sidebar_menu.main_menu.productsTitle',
      icon: 'file',
      showAsTab: false,
      separateRoute: false,
      role:[PermissionType.MANAGE_COMPANY],
      submenuItems: [
        
        {
          link:routes.productManagement,
          label: 'Ürün Yönetimi',
          base: 'product-management',
          icon: 'package',
          role:[PermissionType.MANAGE_COMPANY],
        }
      ]
    },
];